import { EPaymentPlan } from "@/backend/domains/subscription/data/paymentPlans";
import { BaseEntity, TEntityCreating } from "@/backend/shared/repository/BaseEntity";

//

export interface ISubscription extends BaseEntity {
  organizationId: string;

  /** null - если подписки нет в платежной системе, например `plan: "Free"` */
  paymentSubscriptionId: string | null;

  invoiceId: string;
  planId: EPaymentPlan;
  status: ESubscriptionStatus;
  activatedAt: Date;
  billingAt: Date | null;
  nextBillingAt: Date | null;
  expiresAt: Date | null;
  pausedUntil: Date | null;

  nextPlan: null | {
    invoiceId: string;
    planId: EPaymentPlan;
  };
}

//

export type ISubscriptionCreating = TEntityCreating<
  ISubscription,
  "paymentSubscriptionId" | "billingAt" | "nextBillingAt" | "expiresAt" | "pausedUntil" | "nextPlan"
>;

//

export enum ESubscriptionStatus {
  ACTIVE = "active",
  TRIAL = "trial",
  OVERDUE = "overdue",
  SUSPENDED = "suspended",
  CANCELED = "canceled",
  PAUSED = "paused",
}

//

export interface SubscriptionStatus {
  label: string; // Название статуса на русском.
  description: string; // Описание статуса.
  access: boolean; // Доступен ли кабинет
  actionable: boolean; // Выводить сообщение на клиент, что нужно что-то сделать (оплатить тариф).
  color: "green" | "blue" | "red" | "yellow" | "gray";
}

//

export const subscriptionStatusesMap: Record<ESubscriptionStatus, SubscriptionStatus> = {
  active: {
    label: "Активен",
    description: "Подписка оплачена, все функции доступны.",
    access: true,
    actionable: false,
    color: "green",
  },
  trial: {
    label: "Триал",
    description: "Пробный период, все функции доступны.",
    access: true,
    actionable: false,
    color: "green",
  },
  overdue: {
    label: "Истек срок",
    description: "Оплата не прошла, доступ временно сохраняется.",
    access: true,
    actionable: true,
    color: "red",
  },
  suspended: {
    label: "Заморожен",
    description: "Подписка временно отключена из-за просроченной оплаты.",
    access: false,
    actionable: true,
    color: "gray",
  },
  canceled: {
    label: "Отменен",
    description: "Подписка завершена, доступ отключен.",
    access: false,
    actionable: true,
    color: "gray",
  },
  paused: {
    label: "Приостановлен",
    description: "Подписка временно заморожена по вашему запросу.",
    access: false,
    actionable: true,
    color: "gray",
  },
};
